// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_fq-0";